import { useEffect, useState } from 'react'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import AuthService from 'services/auth-service.js'

const MailCreator = () => {
  const [token, setToken] = useState(null)

  useEffect(() => {
    AuthService.getCreatorToken().then(result => setToken(result.token))
  }, [])

  const get_iframe_url = () => {
    const landing_url =
      process.env.REACT_APP_DEVELOPMENT === 'true'
        ? 'https://grile.info/home/'
        : `${process.env.REACT_APP_URL}home/`

    const url_params = {
      app_type: process.env.REACT_APP_TYPE,
      app_url: process.env.REACT_APP_URL,
      app_name: process.env.REACT_APP_NAME,
      css_vars_url: `${landing_url}themes/${process.env.REACT_APP_TYPE}/globals.css`,
    }

    let url = `https://mailer.itoit.ro/creator?token=${token}`

    for (const [key, value] of Object.entries(url_params)) {
      url += `&${key}=${value}`
    }

    return url
  }

  return (
    <DashboardLayout>
      {token !== null && (
        <iframe
          src={get_iframe_url()}
          style={{
            width: '100%',
            height: '90vh',
          }}
        />
      )}
    </DashboardLayout>
  )
}
export default MailCreator
